<template>
  <base-modal>
    <z-form ref="form">
      <z-form-group v-show="!id" class="row">
        <div class="col-2">
          {{ $t('autocaller_v2.operators.field.login') }}
        </div>
        <div class="col-10">
          <z-form-input :rules="{ required: true, max: 32, login: true }">
            <i-input v-model="form.login" />
          </z-form-input>
        </div>
      </z-form-group>
      <z-form-group class="row">
        <div class="col-2">
          {{ $t('autocaller_v2.operators.field.pass') }}
        </div>
        <div class="col-10">
          <z-form-input :rules="{ required: true, min: 6, max: 32, password: true }">
            <i-input v-model="form.password" />
          </z-form-input>
        </div>
      </z-form-group>
      <z-form-group v-show="!id" class="row">
        <div class="col-2">
          {{ $t('autocaller_v2.operators.field.wrtc') }}
        </div>
        <div class="col-10">
          <z-form-input>
            <z-switch v-model="form.wrtc" />
          </z-form-input>
        </div>
      </z-form-group>
      <z-form-group class="row">
        <div class="col-2">
          {{ $t('autocaller_v2.operators.field.status') }}
        </div>
        <div class="col-10">
          <z-form-input>
            <z-switch v-model="form.active" />
          </z-form-input>
        </div>
      </z-form-group>
      <z-form-group v-show="!id" class="row">
        <div class="col-2">
          {{ $t('autocaller_v2.operators.field.instance') }}
        </div>
        <div class="col-10">
          <z-form-input :rules="{ required: true }">
            <select-region-instanse v-model="form.instance_id" />
          </z-form-input>
        </div>
      </z-form-group>
      <z-form-group class="row">
        <div class="col-2">
          {{ $t('autocaller_v2.operators.field.weight') }}
        </div>
        <div class="col-10">
          <z-form-input :rules="{ max: 4 }">
            <input-number v-model="form.weight" class="w-100" :min="0" @on-blur="set_default" />
          </z-form-input>
        </div>
      </z-form-group>

      <div :class="{ 'disabled-block': is_skills_block_loading }">
        <div class="row z-form-item">
          <div class="col-11">
            <div class="">{{ $t('autocaller_v2.operators.skills.title') }}</div>
            <div class="link" @click="add_skill">
              {{ $t('autocaller_v2.operators.skills.add') }}
            </div>
          </div>
          <div class="col-1">
            <tooltip
              placement="top"
              min-width="400"
              max-width="400"
              theme="light"
              :transfer="true"
              :content="$t('autocaller_v2.products.tooltips.usage')"
            >
              <icon size="18" type="ios-help-circle-outline" />
            </tooltip>
          </div>
        </div>

        <div v-if="form.skills.length > 0">
          <div v-for="(skill, index) in form.skills" :key="skill.product_id">
            <div class="row mb-2">
              <div class="col-6">{{ $t('autocaller_v2.operators.skills.product') }}</div>
              <div class="col-6">{{ $t('autocaller_v2.operators.skills.weight') }}</div>
            </div>

            <z-form-group class="row">
              <div class="col-6">
                <i-select
                  v-model="skill.product_id"
                  class="products-select"
                  :filterable="true"
                  allow-create
                  :loading="is_products_list_loading"
                  @on-create="create_product(index, $event)"
                >
                  <i-option
                    v-for="product in products"
                    :key="product.id"
                    :label="product.name"
                    :value="product.id"
                  />
                </i-select>
              </div>
              <div class="col-5">
                <z-form-input :rules="{ max: 4 }">
                  <input-number v-model="skill.weight" class="w-100" :min="0" />
                </z-form-input>
              </div>
              <div class="col-1">
                <tooltip
                  placement="top"
                  min-width="400"
                  max-width="400"
                  theme="light"
                  :transfer="true"
                  :content="$t('autocaller_v2.operators.tooltip.delete')"
                >
                  <icon size="20" type="md-trash" @click="delete_skill(skill.id)" />
                </tooltip>
              </div>
            </z-form-group>
          </div>
        </div>
      </div>
    </z-form>

    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :loading="is_button_loading"
      :disabled="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import SelectRegionInstanse from './campaigns-input-region-instance';
  import { OperatorsService } from '@autocaller_v2/services/OperatorsService';
  import { ProductsService } from '@autocaller_v2/services/ProductsService';
  import { OperatorSkillsService } from '@autocaller_v2/services/OperatorSkillsService';
  import findChanges from '@utils/findChanges';

  export default {
    components: {
      BaseModal,
      SelectRegionInstanse
    },

    props: {
      id: {
        type: [Number, String],
        default: null
      },
      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      form: {
        skills: []
      },
      initial_skills: [],
      is_button_loading: false,
      products: [],
      is_products_list_loading: false,
      is_skills_block_loading: false
    }),

    created() {
      const { id } = this;
      this.is_products_list_loading = true;

      ProductsService.getProducts(id)
        .then((data) => {
          this.products = data;
        })
        .catch((error) => this.$noty.server_error(error))
        .finally(() => (this.is_products_list_loading = false));

      if (id) {
        OperatorsService.getItem(id)
          .then((operator) => {
            if (operator && operator.skills) {
              /* deep copy */
              this.initial_skills = JSON.parse(JSON.stringify(operator.skills));
            }

            return (this.form = {
              ...operator,
              skills: operator?.skills || []
            });
          })
          .catch((error) => this.$noty.server_error(error));
      }
    },

    methods: {
      create_product(index, name) {
        this.is_products_list_loading = true;

        return ProductsService.createItem({ name: name.replace(/^\s+|\s+$/g, '') })
          .then((response) => {
            const { id, name } = response;
            this.products = [...this.products, { id, name }];
            this.form.skills[index] = {
              product_id: id,
              weight: 0,
              product_name: name
            };
          })
          .catch(() => this.$noty.error(this.$t('autocaller_v2.operators.error.create_project')))
          .finally(() => (this.is_products_list_loading = false));
      },

      add_skill() {
        this.form.skills = [...this.form.skills, { product_id: null, weight: null }];
      },
      set_default() {
        if (this.form.weight == null) {
          this.form.weight = 0;
        }
      },
      delete_skill(skill_id) {
        this.is_skills_block_loading = true;
        OperatorSkillsService.deleteSkill(this.id, skill_id)
          .then(() => {
            this.form.skills = this.form.skills.filter((i) => i.id !== skill_id);
          })
          .catch((error) => this.$noty.server_error(error))
          .finally(() => {
            this.is_skills_block_loading = false;
          });
      },

      save_skills: function (operatorId) {
        const { newElements, editedElements } = findChanges(
          this.initial_skills,
          this.form.skills,
          'product_id',
          'weight'
        );

        console.log('newElements', newElements);
        console.log('editedElements', editedElements);

        if (newElements?.length > 0) {
          newElements?.map((i) => {
            return OperatorSkillsService.createSkill(operatorId, {
              product_id: i.product_id,
              weight: i.weight
            }).catch(() => this.$noty.error(this.$t('autocaller_v2.operators.error.create_skill')));
          });
        }

        if (editedElements?.length > 0) {
          editedElements?.map((i) => {
            return OperatorSkillsService.editSkill(this.id, i.id, { weight: i.weight }).catch(() =>
              this.$noty.error(this.$t('autocaller_v2.operators.error.edit_skill'))
            );
          });
        }
      },

      save: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const form = Object.assign({}, this.form);
            this.is_button_loading = true;
            form.wrtc == true ? (form.wrtc = 1) : (form.wrtc = 0);
            form.active == true ? (form.active = 1) : (form.active = 0);
            form.skills = [];

            const request = this.id
              ? OperatorsService.editItem(this.id, form)
              : OperatorsService.createItem(form);
            request
              .then((res) => {
                if (this.id) {
                  this.save_skills(this.id);
                } else {
                  this.save_skills(res.id);
                }
                return this.$emit('success', res);
              })
              .catch((e) => {
                this.$noty.new_server_error(e);
                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>

<style>
  .products-select .ivu-select-dropdown {
    max-width: 500px;
  }
</style>
